module.exports = __webpack_public_path__ + "media/images/one-are-we-7e3c24d89b40ad1bea7c8d0f14bbcdf0.svg";